import React, { useState, useRef } from 'react';
import { TextField, makeStyles, useTheme, Icons } from '~/lib/bn-material-ui';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => {
  return {
    error: {
      '& .MuiInput-underline:before': {
        borderBottomColor: theme.palette.error.main,
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: theme.palette.error.main,
      },
      '&& $calendarIcon': {
        color: theme.palette.error.main,
      },
    },
    dateFieldContainer: {
      position: 'relative',
      fontSize: '1rem',
      width: '100%',
      '& .MuiTextField-root': {
        width: '100%',
      },
      '& input': {
        opacity: 0,
      },
    },
    formattedDate: {
      display: 'flex',
      position: 'absolute',
      top: 0,
      height: '100%',
      width: '100%',
      alignItems: 'center',
      pointerEvents: 'none',
    },
    hasLabel: {
      marginTop: '0.35rem',
    },
    colorSecondary: {
    },
    calendarIcon: {
      marginLeft: 'auto',
    },
    errorText: {
      color: theme.palette.error.main,
    },
  };
});

export function BnDateField(props) {
  const theme = useTheme();
  const [isDirty, setIsDirty] = useState(false);
  const styles = useStyles();
  const inputRef = useRef();
  let { errorMessage, required, formatDate, color = 'primary', minDate, ...defaultProps } = props;

  if (required) {
    if (defaultProps.value === '' || defaultProps.value === undefined) {
      errorMessage = 'This is a required field';
    }
  }

  const _onChange = (e) => {
    setIsDirty(true);
    if (props.onChange) {
      props.onChange(e);
    }
  };
  return (
    <div>
      <div
        role='button'
        tabIndex={0}
        onClick={() => {
          if (defaultProps?.disabled) {
            return;
          }

          inputRef.current.showPicker();
        }}
        className={classNames(styles.dateFieldContainer, isDirty && errorMessage ? styles.error : '')}
      >
        <TextField
          {...defaultProps}
          type='date'
          color={color}
          error={isDirty && errorMessage}
          onKeyDown={(e) => {e.preventDefault();}}
          onChange={(e) => _onChange(e)}
          inputRef={inputRef}
          InputLabelProps={{
            shrink: true,
            ...defaultProps.InputLabelProps,
          }}
          inputProps={{
            min: minDate,
            ...defaultProps.inputProps,
          }}
        />
        <div
          className={classNames(styles.formattedDate, props.label && styles.hasLabel)}
        >
          <div>
            {formatDate ? formatDate(defaultProps.value) : defaultProps.value}
          </div>
          <Icons.CalendarToday fontSize='small' className={styles.calendarIcon} style={{ fill: theme.palette[color].main }} />
        </div>
      </div>
      {isDirty && errorMessage &&
        <div className={styles.errorText}>{errorMessage}</div>
      }
    </div>
  );
}
